import React, { useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Table,
  Typography,
  Popconfirm,
  Divider,
  Tooltip,
  Modal,
  InputNumber,
} from "antd";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";

import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import CustomButton from "../../../../../components/custom/CustomButton";

const { Text } = Typography;

const TermsForm = (props) => {
  const {
    onFinish,
    form,
    loanAccountDetails,
    formData,
    repaymentFrequencyTypeOptions,
    repaymentFrequencyNthDayTypeOptions,
    repaymentFrequencyDaysOfWeekTypeOptions,
    interestTypeOptions,
    amortizationTypeOptions,
    interestCalculationPeriodTypeOptions,
    transactionProcessingStrategyOptions,
    disbursementDataList,
    setDisbursementDataList,
    productTemplate,
    termFrequencyTypeOptions,
  } = props;

  // const [isRatesEnabled, setIsRatesEnabled]=useState(false);
  const isRatesEnabled = loanAccountDetails?.isRatesEnabled;

  const defaultDisbursementColumns = [
    {
      title: "Expected Disbursement Date",
      dataIndex: "expectedDisbursementDate",
    },
    {
      title: "Principal",
      dataIndex: "principal",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) =>
        disbursementDataList.length >= 1 ? (
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDisbursementDelete(record.key)}
            okText="OK"
            cancelText="Cancel"
            okButtonProps={{
              style: {
                backgroundColor: "#92428B",
                color: "white",
                height: "15%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              },
            }}
            cancelButtonProps={{
              style: {
                height: "15%",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              },
            }}
          >
            <CloseOutlined
              style={{
                color: "#92428B",
                fontSize: "15px",
                fontWeight: "bolder",
              }}
            />
          </Popconfirm>
        ) : null,
    },
  ];

  const disbursementColumns = defaultDisbursementColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        // handleSave,
      }),
    };
  });

  const handleDisbursementDelete = (key) => {
    const newData = disbursementDataList.filter((item) => item.key !== key);
    setDisbursementDataList(newData);
  };

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      form={form}
      initialValues={formData}
    >
      <Row style={{ justifyContent: "space-between" }}>
        <Divider orientation="left" orientationMargin="0">
          {labelConfig.paymentInformation}
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={`${labelConfig.principal} (${
              loanAccountDetails?.currency?.displaySymbol
                ? loanAccountDetails?.currency?.displaySymbol
                : "$"
            })`}
            name="principal"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.principal),
              },
            ]}
          >
            <InputNumber
              placeholder={BOM.handlePlaceholderMsg(labelConfig.principal)}
              value={1000}
              className="of-bold-disable-input"
              style={{ width: "100%" }}
              formatter={BOM.FormatAmount}
              parser={BOM.ParseAmount}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.loanTerm}
            name="loanTermFrequency"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.loanTerm),
              },
            ]}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.loanTerm)}
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.loanTermFrequency}</Text>}
            name="loanTermFrequencyType"
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.loanTerm}`,
                "select"
              )}
              options={termFrequencyTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.repaidEvery}
            name="repaymentEvery"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.repaidEvery),
              },
            ]}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.repaidEvery)}
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.repaymentEvery
              }
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.repaymentFrequency}</Text>}
            name="repaymentFrequencyType"
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.option}`,
                "select"
              )}
              options={repaymentFrequencyTypeOptions}
              showSearch
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.repaymentEvery
              }
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.on}</Text>}
            name="repaymentFrequencyNthDayType"
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.option}`,
                "select"
              )}
              options={repaymentFrequencyNthDayTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.dayOfWeek}</Text>}
            name="repaymentFrequencyDayOfWeekType"
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.option}`,
                "select"
              )}
              options={repaymentFrequencyDaysOfWeekTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.numberOfRepayments}
            name="numberOfRepayments"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.numberOfRepayments),
              },
            ]}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.numberOfRepayments
              )}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <div></div>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.firstRepaymentOn}
            name="repaymentsStartingFromDate"
          >
            <DatePicker
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.firstRepaymentOn}`,
                "select"
              )}
              style={{
                width: "100%",
                height: 35,
              }}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestChargedFrom}
            name="interestChargedFromDate"
          >
            <DatePicker
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.interestChargedFrom}`,
                "select"
              )}
              style={{
                width: "100%",
                height: 35,
              }}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <div></div>
        </Col>

        <Divider orientation="left" orientationMargin="0">
          {labelConfig.interestInformation}
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.nominalInterestRate}
            name="interestRatePerPeriod"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.nominalInterestRate),
              },
            ]}
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.nominalInterestRate
              )}
              className="of-bold-disable-input"
              disabled={isRatesEnabled}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.nominalInterestRateFrequency}
            name="nominalInterestRateFrequency"
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.interestMethod}`,
                "select"
              )}
              disabled
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item label={labelConfig.interestMethod} name="interestType">
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.interestMethod}`,
                "select"
              )}
              options={interestTypeOptions}
              showSearch
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.interestType
              }
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.isEqualAmortization}
            name="isEqualAmortization"
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.option}`,
                "select"
              )}
              options={staticConfig.yesOrNoData}
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.amortization}
            name="amortizationType"
            className="of-bold-disable-input"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.amortization),
              },
            ]}
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.amortization}`,
                "select"
              )}
              options={amortizationTypeOptions}
              showSearch
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.amortizationType
              }
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestCalculationPeriod}
            name="interestCalculationPeriodType"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.interestCalculationPeriod),
              },
            ]}
          >
            <Select
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.interestCalculationPeriodType
              }
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.interestCalculationPeriod}`,
                "select"
              )}
              options={interestCalculationPeriodTypeOptions}
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={
              <Tooltip title={labelConfig.calculateInterest}>
                {BOM.SubstringFormat(labelConfig.calculateInterest, 25)}
              </Tooltip>
            }
            name="allowPartialPeriodInterestCalcualtion"
          >
            <Select
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.interestCalculationPeriodType
              }
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.option}`,
                "select"
              )}
              options={staticConfig.yesOrNoData}
              showSearch
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.arrearsTolerance}
            name="inArrearsTolerance"
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.arrearsTolerance
              )}
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.inArrearsTolerance
              }
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.interestFreePeriod}
            name="graceOnInterestCharged"
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.interestFreePeriod
              )}
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.repaymentStrategy}
            name="transactionProcessingStrategyId"
            rules={[
              {
                required: true,
                message: BOM.CheckReqFld(labelConfig.repaymentStrategy),
              },
            ]}
          >
            <Select
              filterOption={(input, option) =>
                (option?.label?.toLowerCase() ?? "").includes(
                  input?.toLowerCase()
                )
              }
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.repaymentStrategy}`,
                "select"
              )}
              options={transactionProcessingStrategyOptions}
              showSearch
              onChange={() =>
                console.log(repaymentFrequencyDaysOfWeekTypeOptions)
              }
              className="of-bold-disable-input"
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.transactionProcessingStrategyId
              }
            />
          </Form.Item>
        </Col>

        <Divider orientation="left" orientationMargin="0">
          {labelConfig.moratorium}
        </Divider>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.onPrincipalPayment}
            name="graceOnPrincipalPayment"
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.onPrincipalPayment
              )}
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.graceOnPrincipalAndInterestPayment
              }
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>

        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.onInterestPayment}</Text>}
            name="graceOnInterestPayment"
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(
                labelConfig.onInterestPayment
              )}
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.graceOnPrincipalAndInterestPayment
              }
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={<Text>{labelConfig.onArrearsAging}</Text>}
            name="graceOnArrearsAgeing"
          >
            <Input
              placeholder={BOM.handlePlaceholderMsg(labelConfig.onArrearsAging)}
              disabled={
                !loanAccountDetails?.product?.allowAttributeOverrides
                  ?.graceOnArrearsAgeing
              }
              className="of-bold-disable-input"
            />
          </Form.Item>
        </Col>
      </Row>

      {loanAccountDetails.multiDisburseLoan === true ? (
        <Row>
          <Divider orientation="left" orientationMargin="0">
            {labelConfig.loanTrancheDetails}
          </Divider>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Tooltip title={labelConfig.maximumAllowedOutstanding}>
                  {BOM.SubstringFormat(
                    labelConfig.maximumAllowedOutstanding,
                    25
                  )}
                </Tooltip>
              }
              name="maxOutstandingLoanBalance"
            >
              <Input
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.maximumAllowedOutstanding
                )}
                style={{ font: "bolder" }}
                className="of-bold-disable-input"
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <DisbursementDataModal
              disbursementDataList={disbursementDataList}
              setDisbursementDataList={setDisbursementDataList}
            />
          </Col>

          <Col span={24} style={{ padding: "0px 8px" }}>
            <Table
              columns={disbursementColumns}
              dataSource={disbursementDataList}
            ></Table>
          </Col>
        </Row>
      ) : null}

      <Divider orientation="left" orientationMargin="0">
        {labelConfig.interestRecalculation}
      </Divider>

      <Row>
        <Col span={8} style={{ padding: "0px 8px" }}>
          <Form.Item
            label={labelConfig.recalculateInterest}
            name="isInterestRecalculationEnabled"
          >
            <Select
              placeholder={BOM.handlePlaceholderMsg(
                `${labelConfig.option}`,
                "select"
              )}
              className="of-bold-disable-input"
              disabled
              options={[
                { label: "Yes", value: true },
                { label: "No", value: false },
              ]}
              showSearch
            />
          </Form.Item>
        </Col>
      </Row>

      {loanAccountDetails?.isInterestRecalculationEnabled === true ? (
        <Row>
          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={labelConfig.daysinYear} name="daysinYear">
              <Input
                disabled
                className="of-bold-disable-input"
                placeholder={BOM.handlePlaceholderMsg(labelConfig.daysinYear)}
                style={{ font: "bolder" }}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Tooltip title={labelConfig.advancePayments}>
                  {BOM.SubstringFormat(labelConfig.advancePayments, 25)}
                </Tooltip>
              }
              name="advancePayments"
            >
              <Input
                disabled
                className="of-bold-disable-input"
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.advancePayments
                )}
                style={{ font: "bolder" }}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item label={labelConfig.daysInMonth} name="daysInMonth">
              <Input
                disabled
                className="of-bold-disable-input"
                placeholder={BOM.handlePlaceholderMsg(labelConfig.daysInMonth)}
                style={{ font: "bolder" }}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Tooltip title={labelConfig.interestRecalculationCompounding}>
                  {BOM.SubstringFormat(
                    labelConfig.interestRecalculationCompounding,
                    25
                  )}
                </Tooltip>
              }
              name="interestRecalculationCompounding"
            >
              <Input
                disabled
                className="of-bold-disable-input"
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.interestRecalculationCompounding
                )}
                style={{ font: "bolder" }}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Tooltip title={labelConfig.calculateInterest}>
                  {BOM.SubstringFormat(labelConfig.FrequencyForRecalculate, 25)}
                </Tooltip>
              }
              name="FrequencyForRecalculate"
            >
              <Input
                disabled
                className="of-bold-disable-input"
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.FrequencyForRecalculate
                )}
                style={{ font: "bolder" }}
              />
            </Form.Item>
          </Col>

          <Col span={8} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={labelConfig.frequencyForCompounding}
              name="recalculationCompoundingFrequency"
            >
              <Input
                disabled
                className="of-bold-disable-input"
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.frequencyForCompounding
                )}
                style={{ font: "bolder" }}
              />
            </Form.Item>
          </Col>
        </Row>
      ) : null}
    </Form>
  );
};

export default TermsForm;

const DisbursementDataModal = (props) => {
  const { disbursementDataList, setDisbursementDataList } = props;

  const [useForm] = Form.useForm();

  const [disbursementTableCount, setDisbursementTableCount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDisbursementDataSave = (formValues) => {
    const newData = {
      id: disbursementTableCount,
      key: disbursementTableCount,
      expectedDisbursementDate: formValues?.expectedDisbursementDate
        ? BOM.DateTime(formValues?.expectedDisbursementDate, "only-date")
        : "-",
      principal: formValues?.principal,
    };
    setDisbursementDataList([...disbursementDataList, newData]);
    setDisbursementTableCount(disbursementTableCount + 1);

    useForm.resetFields();
    setIsModalOpen(false);
  };

  const handleClick = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        type="primary"
        shape="round"
        onClick={handleClick}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginTop: 28,
        }}
      >
        {labelConfig.add}
      </Button>

      <Modal
        title="Add Loan Tranche Details"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={1000}
      >
        <Form
          form={useForm}
          layout="vertical"
          onFinish={handleDisbursementDataSave}
          name="disbursement-data"
        >
          <Row>
            <Divider />

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.expectedDisbursementDate}
                name={"expectedDisbursementDate"}
              >
                <DatePicker
                  placeholder={BOM.handlePlaceholderMsg(
                    `${labelConfig.expectedDisbursementDate}`,
                    "select"
                  )}
                  style={{
                    width: "100%",
                    height: 35,
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.principal} name={"principal"}>
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.principal)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Divider />
            <CustomButton
              content="Save"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              htmlType="submit"
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />

            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </>
  );
};
